import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      id="downld_ic"
      xmlns="http://www.w3.org/2000/svg"
      width="20.178"
      height="20.14"
      viewBox="0 0 20.178 20.14"
    >
      <path
        id="Path_1254"
        data-name="Path 1254"
        d="M61.378,258.059v4.466a1.017,1.017,0,0,1-.032.248h0a.959.959,0,0,1-.934.769H42.159a.956.956,0,0,1-.947-.851.753.753,0,0,1-.013-.172v-4.466a.953.953,0,0,1,1.906,0v3.577H59.478v-3.577a.952.952,0,0,1,1.626-.673A1.006,1.006,0,0,1,61.378,258.059Z"
        transform="translate(-41.2 -243.402)"
      />
      <path
        id="Path_1255"
        data-name="Path 1255"
        d="M119.809,51.684l-4.682,4.682c-.006.013-.019.019-.025.025a1.1,1.1,0,0,1-.616.311c-.019,0-.038.006-.057.006a.69.69,0,0,1-.114.006h0l-.108-.006c-.019,0-.038-.006-.057-.006a1.084,1.084,0,0,1-.616-.311l-.025-.025-4.682-4.682a1.114,1.114,0,0,1,1.576-1.576l2.815,2.814V42.612a1.117,1.117,0,0,1,1.112-1.112,1.136,1.136,0,0,1,.788.324,1.1,1.1,0,0,1,.324.788V52.923l2.814-2.814a1.12,1.12,0,0,1,1.576,0A1.138,1.138,0,0,1,119.809,51.684Z"
        transform="translate(-104.224 -41.5)"
      />
    </svg>
  );
};

export default DownloadIcon;
